module.exports = __webpack_public_path__ + "img/foto37.ed9ee413.jpg";